import { useQuery } from '@apollo/client/react';

import {
  GetMedicationFollowupStatusSettingDocument,
  GetMedicationFollowupStatusSettingQuery,
  GetMedicationFollowupStatusSettingQueryVariables,
} from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useMedicationFollowupSettingStatus = () => {
  const { data, loading, error, refetch } = useQuery<
    GetMedicationFollowupStatusSettingQuery,
    GetMedicationFollowupStatusSettingQueryVariables
  >(GetMedicationFollowupStatusSettingDocument);
  const me = data ? getMe(data) : null;
  const medicationFollowupSettingId = me?.organization.medicationFollowupSetting?.id || null;
  const statusManagement = !!me?.organization.medicationFollowupSetting?.statusManagement;

  return {
    loading,
    error,
    medicationFollowupSettingId,
    statusManagement,
    refetchMedicationFollowupSettingStatus: refetch,
  };
};
